import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import logo from '../../assets/img/MobilAssistance.svg';
import { servicesAPI } from '../../services/api';
import Kvkk from '../../component/application/kvkk';
import Mss from '../../component/application/mesafelisatissozlesme';
import Sartlar from '../../component/application/sartlar';
import Iptal from '../../component/application/iptaliade';
import BankCard from '../../assets/img/onlineislemler/bank_card.png';
import '../../App.css'; // Mevcut stilleri kullan

/**
 * Modern Footer Component - Mevcut tasarımı koruyarak
 * - SEO friendly
 * - Accessible
 * - Dynamic service links from API
 */
const Footer = () => {
  const [services, setServices] = useState([]);
  const [showKvkk, setShowKvkk] = useState(false);
  const [showMss, setShowMss] = useState(false);
  const [showSartlar, setShowSartlar] = useState(false);
  const [showIptal, setShowIptal] = useState(false);

  const normalizeSlug = (text) => {
    if (!text) return '';
    return text.toLowerCase()
      .replace(/ı/g, 'i').replace(/İ/g, 'i')
      .replace(/ğ/g, 'g').replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u').replace(/Ü/g, 'u')
      .replace(/ş/g, 's').replace(/Ş/g, 's')
      .replace(/ö/g, 'o').replace(/Ö/g, 'o')
      .replace(/ç/g, 'c').replace(/Ç/g, 'c')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await servicesAPI.getServices({ flMainCategory: true });
        const data = res?.data?.data || [];
        setServices(data);
      } catch (err) {
        // Error handled silently
      }
    };
    fetchServices();
  }, []);

  const currentYear = new Date().getFullYear();

  return (
    <>
      <section className="o-footer" role="contentinfo">
        <footer>
          <div className="top">
            <div className="pages">
              <ul>
                <Link to="/" aria-label="Mobil Assistance Ana Sayfa">
                  <img src={logo} alt="Mobil Assistance" />
                </Link>
              </ul>
              <ul>
                <h3>Hakkımızda</h3>
                <li><Link className="o-footer__nav__item" to="/tr/kurumsal/mobil-assistance-hakkinda">Amaç</Link></li>
                <li><Link className="o-footer__nav__item" to="/tr/kurumsal/kurumsal-hedefler">Kurumsal Hedeflerimiz</Link></li>
                <li><Link className="o-footer__nav__item" to="/tr/kurumsal/kalite-politikamiz">Kalite Politikamız</Link></li>
                <li><Link className="o-footer__nav__item" to="/tr/kurumsal/kalite-belgelerimiz">Belgelerimiz</Link></li>
                <li><Link className="o-footer__nav__item" to="/tr/kurumsal/tarihcemiz">Tarihçemiz</Link></li>
                <li><Link className="o-footer__nav__item" to="/tr/kurumsal/etik-kurallarimiz">Etik Kurallarımız</Link></li>
                <li><Link className="o-footer__nav__item" to="/tr/kurumsal/kurumsal-kimlik">Kurumsal Kimlik</Link></li>
                <li><Link className="o-footer__nav__item" to="/tr/kurumsal/tanitim-filmi">Tanıtım Filmi</Link></li>
                <li><Link className="o-footer__nav__item" to="/tr/mobil-assistance/insan-kaynaklari">İnsan Kaynakları</Link></li>
              </ul>
              <ul>
                <h3>Hizmetlerimiz</h3>
                {services.length > 0 ? (
                  services.map((service) => {
                    const slug = normalizeSlug(service.dsSlug || service.dsCategories || service.dsTitle);
                    return (
                      <li key={service.idServices}>
                        <Link className="o-footer__nav__item" to={`/tr/hizmetlerimiz/${slug}`}>
                          {service.dsTitle}
                        </Link>
                      </li>
                    );
                  })
                ) : (
                  <>
                    <li><Link className="o-footer__nav__item" to="/tr/hizmetlerimiz">Yol Yardım Hizmeti</Link></li>
                    <li><Link className="o-footer__nav__item" to="/tr/hizmetlerimiz">İkame Araç Hizmeti</Link></li>
                    <li><Link className="o-footer__nav__item" to="/tr/hizmetlerimiz">Çağrı Merkezi Hizmeti</Link></li>
                    <li><Link className="o-footer__nav__item" to="/tr/hizmetlerimiz">Kişiye Özel Yol Yardım Paketleri</Link></li>
                  </>
                )}
              </ul>
              <ul>
                <h3>Online İşlemler</h3>
                <li><Link className="o-footer__nav__item" to="/tr/online-islemler/sozlesme-ara">Sözleşme Ara</Link></li>
                <li>
                  <a 
                    className="o-footer__nav__item" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    href="https://bayi.mobilassistance.com/Bayi_/Giris"
                  >
                    Bayi Girişi
                  </a>
                </li>
                <li><Link className="o-footer__nav__item" to="/tr/online-islemler/tedarikci-basvurusu">Tedarikçi Başvurusu</Link></li>
                <li><Link className="o-footer__nav__item" to="/tr/online-islemler/bayi-agimiz">Tedarikçi Ağımız</Link></li>
                <li><Link className="o-footer__nav__item" to="/tr/online-islemler/bayi-agimiz">Bayi Ağımız</Link></li>
                <li>
                  <a 
                    className="o-footer__nav__item" 
                    href="#!" 
                    onClick={(e) => {
                      e.preventDefault();
                      setShowMss(true);
                    }}
                  >
                    Mesafeli Satış Sözleşmesi
                  </a>
                </li>
                <li>
                  <a 
                    className="o-footer__nav__item" 
                    href="#!" 
                    onClick={(e) => {
                      e.preventDefault();
                      setShowKvkk(true);
                    }}
                  >
                    KVKK
                  </a>
                </li>
              </ul>
              <ul>
                <h3>İletişim</h3>
                <li><Link className="o-footer__nav__item" to="/tr/mobil-assistance/iletisim">İletişim</Link></li>
                <li>
                  <a 
                    className="o-footer__nav__item" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    href="https://www.linkedin.com/company/mobil-assistance/"
                  >
                    LinkedIn
                  </a>
                </li>
                <li>
                  <a 
                    className="o-footer__nav__item" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    href="https://www.instagram.com/mobilassistance/"
                  >
                    Instagram
                  </a>
                </li>
                <li>
                  <a 
                    className="o-footer__nav__item" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    href="https://www.facebook.com/mobilassistance"
                  >
                    Facebook
                  </a>
                </li>
                <li>
                  <a 
                    className="o-footer__nav__item" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    href="https://x.com/mobilassistance"
                  >
                    Twitter
                  </a>
                </li>
                <li>
                  <a 
                    className="o-footer__nav__item" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    href="https://www.youtube.com/channel/UCLg4MfWfFBykwkieU9AKgqA/videos"
                  >
                    Youtube
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="info">
            <div className="legal">
              <a 
                href="#!" 
                onClick={(e) => {
                  e.preventDefault();
                  setShowSartlar(true);
                }}
              >
                Şartlar ve Koşullar
              </a>
              <a 
                href="#!" 
                onClick={(e) => {
                  e.preventDefault();
                  setShowKvkk(true);
                }}
              >
                Gizlilik Politikası
              </a>
              <a 
                href="#!" 
                onClick={(e) => {
                  e.preventDefault();
                  setShowIptal(true);
                }}
              >
                İptal & İade Koşulları
              </a>
            </div>
            <img src={BankCard} width="200px" alt="Kabul edilen ödeme yöntemleri" />
            <div className="copyright">{currentYear} Copyright &copy;Mobil Assistance</div>
          </div>
        </footer>
      </section>

      {/* Legal Modals */}
      <Modal
        show={showKvkk}
        onHide={() => setShowKvkk(false)}
        size="lg"
        centered
        aria-labelledby="kvkk-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="kvkk-modal-title">
            Kişisel Verilerin Korunması Kanunu (KVKK) Bilgilendirme Yazısı
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Kvkk />
        </Modal.Body>
        <Modal.Footer>
          <Button className="c-special-button" onClick={() => setShowKvkk(false)}>
            Okudum Anladım
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showMss}
        onHide={() => setShowMss(false)}
        size="lg"
        centered
        aria-labelledby="mss-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="mss-modal-title">Mesafeli Satış Sözleşmesi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Mss />
        </Modal.Body>
        <Modal.Footer>
          <Button className="c-special-button" onClick={() => setShowMss(false)}>
            Okudum Anladım
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSartlar}
        onHide={() => setShowSartlar(false)}
        size="lg"
        centered
        aria-labelledby="sartlar-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="sartlar-modal-title">Kullanım Koşulları</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Sartlar />
        </Modal.Body>
        <Modal.Footer>
          <Button className="c-special-button" onClick={() => setShowSartlar(false)}>
            Okudum Anladım
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showIptal}
        onHide={() => setShowIptal(false)}
        size="lg"
        centered
        aria-labelledby="iptal-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="iptal-modal-title">
            TÜKETİCİ HAKLARI – CAYMA – İPTAL İADE KOŞULLARI
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Iptal />
        </Modal.Body>
        <Modal.Footer>
          <Button className="c-special-button" onClick={() => setShowIptal(false)}>
            Okudum Anladım
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Footer;

